import { notification } from "antd";

// export function generateSurveyId() {
//     let hexString = '';
//     const characters = '0123456789abcdef';
//     for (let i = 0; i < 24; i++) {
//         hexString += characters.charAt(Math.trunc(Math.random() * characters.length));
//     }
//     return hexString;
// }
  export function   openNotification(type, message,className){
    notification[type]({
      message: message,
      duration: 1.5, 
      className:className
    });
  };

  export function getInitials(name) {
    if (!name) return "";
    const nameParts = name.split(" ");
    const initials = nameParts.map((part) => part[0]).join("").toUpperCase();
    return initials.length > 2 ? initials.slice(0, 2) : initials; 
  };
  